import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PublicScanCompetitorMatrix } from '@brand24-original/llm-types';
import ReportSection from './ReportSection';
import ReportMatrixTable from './ReportMatrixTable';
import { modelLabel } from './modelLabel';

interface ReportCompetitorMatrixProps {
  matrix: PublicScanCompetitorMatrix;
  /** Wspólna dla całego raportu mapa kolorów marek. */
  brandColors: Map<string, string>;
}

export const ReportCompetitorMatrix: React.FC<ReportCompetitorMatrixProps> = ({
  matrix,
  brandColors,
}) => {
  const { t } = useTranslation();

  // Slajd bez danych w ogóle nie wchodzi do raportu — ani na stronie, ani w PDF.
  if (matrix.models.length === 0 || matrix.rows.length === 0) {
    return null;
  }

  return (
    <ReportSection
      title={t('reportMatrixTitle')}
      titleAccent={t('reportMatrixTitleAccent')}
      subtitle={t('reportMatrixSubtitle')}
      footnote={t('reportMatrixFootnote')}
    >
      {/* Modeli bywa dziewięć, a każda kolumna ma swoje minimum — bez `scrollable` tabela ściskała
          kolumny albo uciekała poza kadr z systemowym paskiem. Z nim jedzie na SimpleBarze, a kolumna
          z marką zostaje przyklejona. Przy kilku modelach tabela mieści się w całości i paska nie ma. */}
      <ReportMatrixTable
        columns={matrix.models}
        columnLabel={modelLabel}
        rows={matrix.rows}
        brandColors={brandColors}
        scrollable
      />
    </ReportSection>
  );
};

export default ReportCompetitorMatrix;
